import dataService from 'services/dataService';
import {
  API_DOCTOR_UPDATE_PROFILE,
  API_USERS_PROFILE,
  API_USER_TERMS_OF_SERVICE,
} from 'services/dataService/resources';
import UAParser from 'ua-parser-js';
import {
  getUserPlatformMode,
  toggleUserPlatformMode,
} from 'utils/accessManager/helpers';
import { PLATFORM_MODE_RPM } from 'utils/accessManager/constants';
import { showResult } from 'utils';

const DEFAULT_PLATFORM_MODE = PLATFORM_MODE_RPM;

export const DEFAULT_USER_DETAILS = {
  guid: '',
  userType: '',
  agencies: [],
  deviceType: '',
  loginGuid: '',
  firstName: '',
  lastName: '',
  title: '',
  email: '',
  birthDate: '',
  phone: '',
  timezone: '',
  alertSms: false,
  alertEmail: false,
  adminFlag: false,
  logoutFlag: false,
  platformMode: DEFAULT_PLATFORM_MODE,
  termsOfService: false,
};

const user = {
  state: { ...DEFAULT_USER_DETAILS },
  reducers: {
    setUser(state, payload) {
      return {
        ...state,
        ...payload,
        logoutFlag: false,
      };
    },
    logout() {
      return {
        ...DEFAULT_USER_DETAILS,
        logoutFlag: true,
      };
    },
    device(state, payload) {
      return {
        ...state,
        deviceType: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async setDevice() {
      const parser = new UAParser();
      const result = parser.getResult();
      dispatch.user.device(result.device.type);
    },
    async acceptTermsofService() {
      const { data, error } = await dataService.updateOnly(
        API_USER_TERMS_OF_SERVICE,
      );
      if (error) showResult(error);
      if (data) {
        const platformMode = getUserPlatformMode(data);
        dispatch.user.setUser({ ...data, platformMode });
      }
    },
    async getProfile() {
      const { data, error, status } = await dataService.getOnly(
        API_USERS_PROFILE,
      );

      if (status === 403) {
        dispatch.user.setUser({ isBlocked: true, roleNames: [] });
        return;
      }

      if (error) {
        dispatch.user.logout();
      }
      if (data) {
        const platformMode = getUserPlatformMode(data);
        dispatch.user.setUser({ ...data, platformMode });
      }
    },
    async toggleAlerts(postData, state) {
      const { guid } = state.user;
      const { error, data } = await dataService.updateOnly(
        API_DOCTOR_UPDATE_PROFILE,
        {
          guid,
          ...postData,
        },
      );
      if (!error) {
        dispatch.user.setUser({
          ...postData,
        });
      }
      return { error, data };
    },
    switchPlatformMode(data, state) {
      const { user: currentUser } = state;
      const platformMode = toggleUserPlatformMode(currentUser);
      dispatch.user.setUser({ ...user, platformMode });

      return platformMode;
    },
  }),
};

export default user;
